import React from 'react';
import * as ds from './dataService';
import { appFormUtil } from 'modules/common';
import { useParams } from 'react-router-dom';
import { StyledDropDown } from 'modules/components/layer01';


export type SelectFolderFieldProps<T extends object> = appFormUtil.SelectFieldProps<T>;

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectFolderFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={[
        ...data,
        {
          id: '', name: '', displayName: 'None'
        }
      ]}
    />
  );
};
